import { GenIcon } from '../helpers/IconBase.es.js';

const WrenchFilled = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 16 16", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.6809 1.63402C7.47139 0.78833 8.81325 0.788338 9.60375 1.63402L9.81762 1.86351C10.2119 2.28537 10.7698 2.51681 11.3469 2.4973L11.6604 2.48656C12.8174 2.44746 13.7659 3.39591 13.7268 4.55297L13.7161 4.86644C13.6966 5.44353 13.928 6.00147 14.3498 6.39574L14.5793 6.60961C15.425 7.4001 15.425 8.74196 14.5793 9.53246L14.3498 9.74633C13.928 10.1406 13.6966 10.6985 13.7161 11.2756L13.7268 11.5891C13.7659 12.7462 12.8174 13.6946 11.6604 13.6555L11.3469 13.6448C10.7698 13.6253 10.2119 13.8567 9.81762 14.2786L9.60375 14.508C8.81325 15.3537 7.47139 15.3538 6.6809 14.508L6.46703 14.2786C6.12235 13.9098 5.65271 13.6868 5.15453 13.6496L7.7434 11.0608L7.84203 11.0871C9.07769 11.4166 10.4052 11.0734 11.3264 10.1516C12.4983 8.98019 12.7151 7.17394 11.887 5.77074C11.8727 5.77726 11.1849 6.45654 9.8264 7.81176C9.4797 8.15764 8.91772 8.15718 8.57152 7.81078C8.22588 7.46443 8.22558 6.90303 8.57152 6.55687L10.6164 4.51195C9.21111 3.66558 7.40532 3.88275 6.23461 5.05394C5.7872 5.50137 5.46533 6.05896 5.30101 6.67015C5.13675 7.28147 5.13524 7.92565 5.29808 8.53734L5.32543 8.63597L2.56371 11.3967L2.56859 11.2756C2.58809 10.6985 2.35666 10.1406 1.9348 9.74633L1.70531 9.53246C0.859627 8.74196 0.859619 7.4001 1.70531 6.60961L1.9348 6.39574C2.35666 6.00147 2.58809 5.44353 2.56859 4.86644L2.55785 4.55297C2.51875 3.39591 3.4672 2.44746 4.62426 2.48656L4.93773 2.4973C5.51482 2.51681 6.07276 2.28537 6.46703 1.86351L6.6809 1.63402Z",
          fill: "white"
        }
      }
    ]
  })(props);
};

export { WrenchFilled };
